import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialog,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { AdminService } from '../admin/admin.service';
import { NgxLoadingModule } from 'ngx-loading';
import { EditAutoReportsModalComponent } from './edit-auto-reports-modal/edit-auto-reports-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { WarnDialogComponent } from '../warn-dialog/warn-dialog.component';
import { Location } from '@angular/common';
import { SharedComponentsModule } from '../shared-components/shared-components.module';

@Component({
  selector: 'app-auto-reports',
  imports: [
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    NgxLoadingModule,
    KENDO_GRID,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    SharedComponentsModule,
  ],
  templateUrl: './auto-reports.component.html',
  styleUrl: './auto-reports.component.scss',
})
export class AutoReportsComponent implements OnInit {
  private adminService = inject(AdminService);
  private dialog = inject(MatDialog);
  private location = inject(Location);
  data = inject(MAT_DIALOG_DATA);

  @ViewChild('automatedReportsDialog') automatedReportsDialog: TemplateRef<any>;
  cancel: any;
  content: any;
  loading: boolean;
  gridData = null;

  weekdayValueToLabelMap: { [key: number]: string } = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
  };

  columns = [
    { field: 'reportName', title: 'Name', width: 150 },
    { field: 'reportDescription', title: 'Description', width: 200 },
    { field: 'grid', title: 'Grid', width: 150 },
    { field: 'Name', title: 'Saved Filter Name', width: 200 },
    { field: 'cadenceValue', title: 'Cadence Value', width: 150 },
  ];
  editMode: boolean;

  constructor() {
    this.cancel = this.data.cancel;
    this.content = 'test';
  }

  ngOnInit(): void {
    this.getReportData();
  }

  getReportData(): void {
    this.loading = true;
    this.adminService.getAutomatedReportData('rb').subscribe({
      next: res => {
        this.gridData = res;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        throw new Error('Error retreiving data.');
      },
    });
  }

  editRecord(dataItem: any): void {
    let editDialog = this.dialog.open(EditAutoReportsModalComponent, {
      minWidth: '80vw',
      maxWidth: '80vw',
      data: { createNew: false, dataItem: dataItem },
    });
    editDialog.afterClosed().subscribe({
      next: result => {
        if (result !== 'cancel') {
          this.adminService
            .patchAutomatedReportData('rb', { payload: result })
            .subscribe(res => {
              this.getReportData();
            });
        }
        editDialog = null;
      },
      error: () => {
        editDialog = null;
        throw new Error('Request failed.');
      },
    });
  }

  back(action: string): void {
    if (action === 'edit') {
      this.editMode = false;
    }
  }

  deleteRecord(dataItem: any): void {
    const reqBody = { id: +dataItem.id };
    let dialogRef = this.dialog.open(WarnDialogComponent, {
      panelClass: 'warn-dialog',
      data: {
        headline: 'Warning',
        content: `Are you sure you would like to delete this automated report?`,
        confirm: 'Delete',
        cancel: 'Cancel',
        hideCancel: false,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'continue') {
        this.adminService.deleteAutomatedReportData(reqBody).subscribe(
          res => {
            this.getReportData();
          },
          () => {
            throw new Error('Delete request failed');
          }
        );
      }
      dialogRef = null;
    });
  }

  createNew(ev): void {
    let editDialog = this.dialog.open(EditAutoReportsModalComponent, {
      minWidth: '80vw',
      maxWidth: '80vw',
      data: { createNew: true },
    });
    editDialog.afterClosed().subscribe({
      next: result => {
        if (result !== 'cancel') {
          this.adminService
            .postAutomatedReportData('rb', { payload: result })
            .subscribe(res => this.getReportData());
        }
        editDialog = null;
      },
      error: () => {
        editDialog = null;
        throw new Error('Request failed.');
      },
    });
  }

  getWeekdayLabel(weekday: number): string {
    return this.weekdayValueToLabelMap[weekday] || 'Unknown Label';
  }

  getMonthlySuffix(day: number): string {
    if (day >= 11 && day <= 13) {
      return `${day}th`; // Special case for 11th, 12th, 13th
    }

    switch (day % 10) {
      case 1:
        return `${day}st`;
      case 2:
        return `${day}nd`;
      case 3:
        return `${day}rd`;
      default:
        return `${day}th`;
    }
  }
}
